module.exports = __webpack_public_path__ + "img/22.5.COD.8d37a855.png";